export const IS_HIDDEN_FROM_PORTAL = 'is_hidden_from_portal';
export const SHOULD_AUTO_ADVANCE_WHEN_LABELS_COMPLETE =
  'should_auto_advance_when_labels_complete';
